export const LOCAL_AUTH_KEY = 'crm_auth'
